/**
 * HTTP Status constants and utilities
 */
export const UNKNOWN = 0;
/**
 * HTTP Status constants and utilities
 */
export const CONTINUE = 100;
/**
 * HTTP Status constants and utilities
 */
export const SWITCHING_PROTOCOLS = 101;
/**
 * HTTP Status constants and utilities
 */
export const PROCESSING = 102;
/**
 * HTTP Status constants and utilities
 */
export const OK = 200;
/**
 * HTTP Status constants and utilities
 */
export const CREATED = 201;
/**
 * HTTP Status constants and utilities
 */
export const ACCEPTED = 202;
/**
 * HTTP Status constants and utilities
 */
export const NON_AUTHORITATIVE_INFORMATION = 203;
/**
 * HTTP Status constants and utilities
 */
export const NO_CONTENT = 204;
/**
 * HTTP Status constants and utilities
 */
export const RESET_CONTENT = 205;
/**
 * HTTP Status constants and utilities
 */
export const PARTIAL_CONTENT = 206;
/**
 * HTTP Status constants and utilities
 */
export const MULTI_STATUS = 207;
/**
 * HTTP Status constants and utilities
 */
export const ALREADY_REPORTED = 208;
/**
 * HTTP Status constants and utilities
 */
export const MULTIPLE_CHOICES = 300;
/**
 * HTTP Status constants and utilities
 */
export const MOVED_PERMANENTLY = 301;
/**
 * HTTP Status constants and utilities
 */
export const FOUND = 302;
/**
 * HTTP Status constants and utilities
 */
export const SEE_OTHER = 303;
/**
 * HTTP Status constants and utilities
 */
export const NOT_MODIFIED = 304;
/**
 * HTTP Status constants and utilities
 */
export const USE_PROXY = 305;
/**
 * HTTP Status constants and utilities
 */
export const TEMPORARY_REDIRECT = 307;
/**
 * HTTP Status constants and utilities
 */
export const PERMANENT_REDIRECT = 308;
/**
 * HTTP Status constants and utilities
 */
export const BAD_REQUEST = 400;
/**
 * HTTP Status constants and utilities
 */
export const UNAUTHORIZED = 401;
/**
 * HTTP Status constants and utilities
 */
export const PAYMENT_REQUIRED = 402;
/**
 * HTTP Status constants and utilities
 */
export const FORBIDDEN = 403;
/**
 * HTTP Status constants and utilities
 */
export const NOT_FOUND = 404;
/**
 * HTTP Status constants and utilities
 */
export const METHOD_NOT_ALLOWED = 405;
/**
 * HTTP Status constants and utilities
 */
export const NOT_ACCEPTABLE = 406;
/**
 * HTTP Status constants and utilities
 */
export const PROXY_AUTHENTICATION_REQUIRED = 407;
/**
 * HTTP Status constants and utilities
 */
export const REQUEST_TIMEOUT = 408;
/**
 * HTTP Status constants and utilities
 */
export const CONFLICT = 409;
/**
 * HTTP Status constants and utilities
 */
export const GONE = 410;
/**
 * HTTP Status constants and utilities
 */
export const LENGTH_REQUIRED = 411;
/**
 * HTTP Status constants and utilities
 */
export const PRECONDITION_FAILED = 412;
/**
 * HTTP Status constants and utilities
 */
export const REQUEST_TOO_LONG = 413;
/**
 * HTTP Status constants and utilities
 */
export const REQUEST_URI_TOO_LONG = 414;
/**
 * HTTP Status constants and utilities
 */
export const UNSUPPORTED_MEDIA_TYPE = 415;
/**
 * HTTP Status constants and utilities
 */
export const REQUESTED_RANGE_NOT_SATISFIABLE = 416;
/**
 * HTTP Status constants and utilities
 */
export const EXPECTATION_FAILED = 417;
/**
 * HTTP Status constants and utilities
 */
export const IM_A_TEAPOT = 418;
/**
 * HTTP Status constants and utilities
 */
export const INSUFFICIENT_SPACE_ON_RESOURCE = 419;
/**
 * HTTP Status constants and utilities
 */
export const METHOD_FAILURE = 420;
/**
 * HTTP Status constants and utilities
 */
export const UNPROCESSABLE_ENTITY = 422;
/**
 * HTTP Status constants and utilities
 */
export const LOCKED = 423;
/**
 * HTTP Status constants and utilities
 */
export const FAILED_DEPENDENCY = 424;
/**
 * HTTP Status constants and utilities
 */
export const PRECONDITION_REQUIRED = 428;
/**
 * HTTP Status constants and utilities
 */
export const TOO_EARLY = 425;
/**
 * HTTP Status constants and utilities
 */
export const TOO_MANY_REQUESTS = 429;
/**
 * HTTP Status constants and utilities
 */
export const REQUEST_HEADER_FIELDS_TOO_LARGE = 431;
/**
 * HTTP Status constants and utilities
 */
export const CONNECTION_CLOSED_WITHOUT_RESPONSE = 444;
/**
 * HTTP Status constants and utilities
 */
export const UNAVAILABLE_FOR_LEGAL_REASONS = 451;
/**
 * HTTP Status constants and utilities
 */
export const CLIENT_CLOSED_REQUEST = 499;
/**
 * HTTP Status constants and utilities
 */
export const INTERNAL_SERVER_ERROR = 500;
/**
 * HTTP Status constants and utilities
 */
export const NOT_IMPLEMENTED = 501;
/**
 * HTTP Status constants and utilities
 */
export const BAD_GATEWAY = 502;
/**
 * HTTP Status constants and utilities
 */
export const SERVICE_UNAVAILABLE = 503;
/**
 * HTTP Status constants and utilities
 */
export const GATEWAY_TIMEOUT = 504;
/**
 * HTTP Status constants and utilities
 */
export const HTTP_VERSION_NOT_SUPPORTED = 505;
/**
 * HTTP Status constants and utilities
 */
export const INSUFFICIENT_STORAGE = 507;
/**
 * HTTP Status constants and utilities
 */
export const NETWORK_AUTHENTICATION_REQUIRED = 511;
/**
 * HTTP Status constants and utilities
 */
export const NETWORK_CONNECT_TIMEOUT_ERROR = 599;
/**
 * HTTP Status constants and utilities
 */
export const ALL_HTTP_STATUS = [
    UNKNOWN,
    CONTINUE,
    SWITCHING_PROTOCOLS,
    PROCESSING,
    OK,
    CREATED,
    ACCEPTED,
    NON_AUTHORITATIVE_INFORMATION,
    NO_CONTENT,
    RESET_CONTENT,
    PARTIAL_CONTENT,
    MULTI_STATUS,
    ALREADY_REPORTED,
    MULTIPLE_CHOICES,
    MOVED_PERMANENTLY,
    FOUND,
    SEE_OTHER,
    NOT_MODIFIED,
    USE_PROXY,
    TEMPORARY_REDIRECT,
    PERMANENT_REDIRECT,
    BAD_REQUEST,
    UNAUTHORIZED,
    PAYMENT_REQUIRED,
    FORBIDDEN,
    NOT_FOUND,
    METHOD_NOT_ALLOWED,
    NOT_ACCEPTABLE,
    PROXY_AUTHENTICATION_REQUIRED,
    REQUEST_TIMEOUT,
    CONFLICT,
    GONE,
    LENGTH_REQUIRED,
    PRECONDITION_FAILED,
    REQUEST_TOO_LONG,
    REQUEST_URI_TOO_LONG,
    UNSUPPORTED_MEDIA_TYPE,
    REQUESTED_RANGE_NOT_SATISFIABLE,
    EXPECTATION_FAILED,
    IM_A_TEAPOT,
    INSUFFICIENT_SPACE_ON_RESOURCE,
    METHOD_FAILURE,
    UNPROCESSABLE_ENTITY,
    LOCKED,
    FAILED_DEPENDENCY,
    PRECONDITION_REQUIRED,
    TOO_EARLY,
    TOO_MANY_REQUESTS,
    REQUEST_HEADER_FIELDS_TOO_LARGE,
    CONNECTION_CLOSED_WITHOUT_RESPONSE,
    UNAVAILABLE_FOR_LEGAL_REASONS,
    CLIENT_CLOSED_REQUEST,
    INTERNAL_SERVER_ERROR,
    NOT_IMPLEMENTED,
    BAD_GATEWAY,
    SERVICE_UNAVAILABLE,
    GATEWAY_TIMEOUT,
    HTTP_VERSION_NOT_SUPPORTED,
    INSUFFICIENT_STORAGE,
    NETWORK_AUTHENTICATION_REQUIRED,
    NETWORK_CONNECT_TIMEOUT_ERROR,
];
/**
 * Determines if the given HTTP status cannot have content in the response body.
 */
export const statusHasNoContent = (status) => status === NO_CONTENT || status === RESET_CONTENT;
/**
 * Determines if the given number is a known HTTP status.
 */
export const isKnownStatus = (status) => ALL_HTTP_STATUS.includes(status);
/**
 * Determines if the given HTTP status is a success status.
 */
export const isSuccessStatus = (status) => status >= OK && status < MULTIPLE_CHOICES;
/**
 * Determines if the given HTTP status is a client error status.
 */
export const isClientErrorStatus = (status) => status >= BAD_REQUEST && status < INTERNAL_SERVER_ERROR;
/**
 * Determines if the given HTTP status is a server error status.
 */
export const isServerErrorStatus = (status) => status >= INTERNAL_SERVER_ERROR;
